import {gql} from '@apollo/client';

import {FormattedAge, LabResultMetric} from '#apollo/schema';

export const myTallyAgeFormattedAgeFragment = gql`
  fragment MyTallyAgeFormattedAgeFragment on FormattedAge {
    months
    years
  }
`;

export const myTallyAgeLabResultMetricFragment = gql`
  fragment MyTallyAgeLabResultMetric on LabResultMetric {
    id
    percentile
    type
  }
`;

export const myTallyAgeLabAssessmentFragment = gql`
  ${myTallyAgeFormattedAgeFragment}
  ${myTallyAgeLabResultMetricFragment}

  fragment MyTallyAgeLabAssessmentFragment on LabAssessment {
    deltaAge
    formattedBioAge {
      ...MyTallyAgeFormattedAgeFragment
    }
    formattedChronologicalAge {
      ...MyTallyAgeFormattedAgeFragment
    }
    formattedDeltaAge {
      ...MyTallyAgeFormattedAgeFragment
    }
    id
    labResultMetrics {
      ...MyTallyAgeLabResultMetric
    }
    reportUrl
  }
`;

export interface TallyAgeHeaderProps {
  /**
   * The unformatted deltaAge for a given LabAssessment.
   *
   * @default 0
   */
  deltaAge?: number;
  /**
   * The `formattedBioAge` for a given LabAssessment.
   */
  formattedBioAge: FormattedAge;
  /**
   * The `formattedChronologicalAge` for a given LabAssessment.
   */
  formattedChronologicalAge: FormattedAge;
  /**
   * The `formattedDeltaAge` for a given LabAssessment.
   */
  formattedDeltaAge: FormattedAge;
  /**
   * An array of LabResultMetrics for a given LabAssessment.
   *
   * @default []
   */
  labResultMetrics?: LabResultMetric[];
  /**
   * The `reportUrl` for a given LabAssessment.
   */
  labResultReportUrl: string;
  /**
   * The `registeredDate` DateString for the LabSubmission associated with a
   * given LabAssessment.
   */
  registeredDate: string;
}
